import React from "react";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";

const PadlockIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => {
  return (
    <Svg
      width={width}
      height={height}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 24 24"
      {...props}
    >
      <Path
        d="M17.444 11H6.556C5.696 11 5 11.814 5 12.818v6.364C5 20.186 5.696 21 6.556 21h10.888c.86 0 1.556-.814 1.556-1.818v-6.364C19 11.814 18.304 11 17.444 11ZM7.618 11V7.444c0-1.178.474-2.309 1.318-3.142A4.529 4.529 0 0 1 12.118 3c1.194 0 2.338.468 3.182 1.302a4.417 4.417 0 0 1 1.318 3.142V11"
        stroke={color}
        fill="transparent"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default PadlockIcon;
